export class GetAasConfigResponse {
    address: string = '';
    enabled: boolean = false;
}